import React, { ReactNode, useEffect } from "react";
import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalClose,
  ModalBody,
} from "./modal.styles";

interface ModalProps {
  isOpen: boolean;
  toggle: () => void;
  header?: ReactNode;
  full?: boolean;
  children: ReactNode;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  toggle,
  header,
  full = false,
  children,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") toggle();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isOpen, toggle]);

  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={toggle}>
      <ModalContainer full={full} onClick={(e) => e.stopPropagation()}>
        {header && (
          <ModalHeader>
            {header}
            <ModalClose aria-label="Close" onClick={toggle}>
              &times;
            </ModalClose>
          </ModalHeader>
        )}
        <ModalBody>{children}</ModalBody>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default Modal;
